import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import request from './utils/request'
import md5 from 'js-md5';

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

Vue.prototype.$md5 = md5;
Vue.prototype.$get = request.get
Vue.prototype.$post = request.post
Vue.prototype.$downloadFile = request.downloadFile

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
